import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ApiService } from '../../../shared/services/api.service';
import { ToastrService } from 'ngx-toastr';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';

@Component({
	selector: 'app-scale-form',
	templateUrl: './scale-form.component.html',
	styleUrl: './scale-form.component.css'
})
export class ScaleFormComponent implements OnInit {
	moduleForm!: FormGroup;
	showLoader = false;
	pageLoading = false;
	@Input() uId: any = null;
	@Output() created = new EventEmitter<any>();
	@Output() cleared = new EventEmitter<any>();
	customError: any = {};
	UserModuleAccess: any = "Full";
	formSubmitted = false;
	categoryList: any = [];
	scaleList: any = [];
	questionList: any = [];

	constructor(private toastr: ToastrService, private apiService: ApiService, private formBuilder: FormBuilder, private router: Router, private activeRoute: ActivatedRoute) {
		this.moduleForm = this.formBuilder.group({
			Cat_id: [null, [Validators.required]],
			acronym: [null, [Validators.required]],
			scale_name: [null, [Validators.required]],
			parent: [null],
			description: [""],
			questions: this.formBuilder.array([])
		});
	}

	get f() { return this.moduleForm.controls; }

	get get_rows() {
		return this.moduleForm.controls['questions'] as FormArray;
	}

	addRow() {
		const form = this.formBuilder.group({
			que: [null, [Validators.required]],
			condition: [null, [Validators.required]],
			value: [null, [Validators.required]]
		});
		this.get_rows.push(form);
	}

	deleteRow(index: number) {
		this.get_rows.at(index).markAsUntouched();
		this.get_rows.at(index).updateValueAndValidity();
		this.get_rows.removeAt(index);
	}

	ngOnInit(): void {
		this.getCategoryList();
		this.getScaleList();
		this.getQuestionList();
		if (this.uId) {
			this.getDetails();
		} else {
			/* this.addRow(); */
		}
	}

	getScaleList() {
		this.apiService.getAllScaleList().subscribe({
			next: (data: any) => {
				this.scaleList = data;
			}, error: (error) => {
				this.scaleList = [];
			}
		});
	}

	getQuestionList() {
		this.apiService.getQuestionBankList().subscribe({
			next: (data: any) => {
				this.questionList = data.data;
			}, error: (error) => {
				this.questionList = [];
			}
		});
	}

	getCategoryList() {
		this.apiService.getScaleCategoryList().subscribe({
			next: (data: any) => {
				data.map((d: any) => {
					delete d.encrypt_cat_id;
				});
				this.categoryList = data;
			}, error: (error) => {
				this.categoryList = [];
			}
		});
	}

	clearForm() {
		this.moduleForm.reset();
		this.cleared.emit();
	}

	getDetails() {
		this.pageLoading = true;
		this.apiService.getScaleDetails(this.uId).subscribe({
			next: (data: any) => {
				this.pageLoading = false;
				this.f.Cat_id.setValue({ cat_id: data.Cat_id, category_name: data.Cat_name });
				/* this.f.Cat_id.setValue(data.Cat_name); */
				/* this.f.Cat_id.setValue(data.Cat_id); */
				this.f.acronym.setValue(data.acronym);
				this.f.scale_name.setValue(data.scale_name);
				this.f.parent.setValue(data.parent ? data.parent : null);
				this.f.description.setValue(data.description);
				let questions: any = data.questions;
				let len = questions.length;
				for (let i = 0; i < len; i++) {
					this.addRow();
					this.get_rows.controls[i].get("que")?.setValue(questions[i].que);
					this.get_rows.controls[i].get("condition")?.setValue(questions[i].condition);
					this.get_rows.controls[i].get("value")?.setValue(questions[i].value);
				}
			}, error: (error) => {
				this.pageLoading = false;
				if (error.status == 401) { return }
				this.toastr.error("Something went wrong", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			}
		});
	}

	clearCustomError() {
		Object.keys(this.f).forEach(key => {
			if (this.f[key].hasError('incorrect')) {
				try {
					delete this.f[key].errors?.incorrect;
					this.f[key].updateValueAndValidity();
				} catch (error) { }
			}
		});
		this.customError = {};
	}

	saveData() {
		this.formSubmitted = true;
		this.clearCustomError();
		if (this.moduleForm.invalid) {
			this.toastr.info("Please check required parameters.", 'Warning', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		let cat: any = this.f.Cat_id.value;
		if (typeof cat === "string") {
			let matchFound = false;
			let len = this.categoryList.length;
			for (let i = 0; i < len; i++) {
				let d: any = this.categoryList[i];
				try {
					if (cat.toLowerCase() == d.category_name.toLowerCase()) {
						cat = { "cat_id": d.cat_id, category_name: d.category_name };
						matchFound = true;
						break;
					}
				} catch (error) { }
			};
			if (!matchFound) {
				cat = { "cat_id": cat };
			}
		}
		let questions: any = [];
		for (let i = 0; i < this.get_rows.controls.length; i++) {
			questions.push({
				que: this.get_rows.controls[i].get("que")?.value,
				condition: this.get_rows.controls[i].get("condition")?.value,
				value: this.get_rows.controls[i].get("value")?.value,
			});
		}
		let payload: any = {
			"Cat_id": cat,
			/* "Cat_id": this.f.Cat_id.value, */
			"acronym": this.f.acronym.value,
			"description": this.f.description.value,
			"questions": questions,
			"parent": this.f.parent.value ? this.f.parent.value : null,
			"scale_name": this.f.scale_name.value,
			"id": this.uId
		}
		this.showLoader = true;
		this.apiService.createUpdateScale(payload).subscribe({
			next: (data: any) => {
				this.showLoader = false;
				this.toastr.success("Saved successfully", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.created.emit(data);
			}, error: (error) => {
				this.showLoader = false;
				if (error.status == 409) {
					Swal.fire({
						title: 'Already Exists',
						html: 'Scale with name <strong>' + this.f.scale_name.value + '</strong> already exists. Do you want to restore it?',
						icon: 'question',
						showCancelButton: true,
						showConfirmButton: true,
						confirmButtonText: 'Yes, Restore!',
						cancelButtonText: 'Cancel',
						confirmButtonColor: '#3e4fb1'
					}).then((result) => {
						if (result.value) {
							this.apiService.restoreScale(error.error.encryptid).subscribe({
								next: (data1: any) => {
									this.toastr.success("Restored successfully", 'Success', {
										timeOut: 3000,
										tapToDismiss: true,
										closeButton: true
									});
									this.created.emit(error.error.encryptid);
								}, error: (error) => {
									this.toastr.error("Something went wrong", 'Error', {
										timeOut: 3000,
										tapToDismiss: true,
										closeButton: true
									});
								}
							});
						}
					})
				} else {
					let errorMsg = "Something went wrong.";
					if (error.status == 400) {
						errorMsg = "Scale name already exists";
					}
					this.toastr.error(errorMsg, 'Error', {
						timeOut: 3000,
						tapToDismiss: true,
						closeButton: true,
					});
				}
			}
		});
	}

	showError(field: string) {
		if (this.f[field].invalid && (this.formSubmitted || this.f[field].touched || this.f[field].dirty)) {
			return true;
		}
		return false;
	}

	showError2(index: number, field: string) {
		let f: any = this.get_rows.controls[index].get(field);
		if (f.invalid && (this.formSubmitted || f.touched || f.dirty)) {
			return true;
		}
		return false;
	}
}
